import { createReducer } from 'deox';
import { produce } from 'immer';

import {
  setNotification,
  setFirstStart,
  setIsLocationCheck,
  setWindowWidth,
  setCurrentLanguage, setCurrentCountry,
} from './actions';
import { AppTypes } from './types';

const initialState: AppTypes = {
  notification: {
    status: false,
    text: '',
    type: 'success',
  },
  firstStart: true,
  isLocationCheck: false,
  windowWidth: 1980,
  currentLanguage: localStorage.getItem('lng')?.toUpperCase() || 'en',
  currentCountry: localStorage.getItem('country') || 'US',
};

export const appReducer = createReducer(initialState, handleAction => [
  handleAction(setNotification, (state, { payload }) =>
    produce(state, draft => {
      draft.notification.status = payload.status;
      if (payload.text) draft.notification.text = payload.text;
      if (payload.type) draft.notification.type = payload.type;
    }),
  ),
  handleAction(setFirstStart, (state, { payload }) =>
    produce(state, draft => {
      draft.firstStart = payload;
    }),
  ),
  handleAction(setIsLocationCheck, (state, { payload }) =>
    produce(state, draft => {
      draft.isLocationCheck = payload;
    }),
  ),
  handleAction(setWindowWidth, (state, { payload }) =>
    produce(state, draft => {
      draft.windowWidth = payload;
    }),
  ),
  handleAction(setCurrentLanguage, (state, { payload }) =>
    produce(state, draft => {
      draft.currentLanguage = payload;
    }),
  ),
  handleAction(setCurrentCountry, (state, { payload }) =>
    produce(state, draft => {
      draft.currentCountry = payload;
    }),
  ),
]);
